<div class="casedetails customerdetails">
    <button class="back-to-list" (click)="goToList()"><i class="fa fa-angle-left"></i> Tilbage til liste</button>
    <div *ngIf="customer">
        <div class="casedetailpanel">
            <form (ngSubmit)="onSubmitUpdateCustomer()" #f="ngForm" autocomplete="off">

                <div class="form-group" [ngClass]="{ 'has-error': f.submitted && !username.valid }">
                    <label for="firstName">Navn og fornavn</label>
                    <input type="text" class="form-control" name="fullName" [(ngModel)]="customer.fullName" #fullName="ngModel" required />
                    <div *ngIf="f.submitted && !fullName.valid" class="help-block">Navn er obligatorisk</div>
                </div>
                <div class="form-group" [ngClass]="{ 'has-error': f.submitted && !username.valid }">
                    <label for="companyIsIndustry">Registrér som erhvervkunde</label>
                    <input type="checkbox" class="form-control" name="companyIsIndustry" [(ngModel)]="customer.customerIsIndustry" #companyName="ngModel" />
                </div>
                <div class="form-group" [ngClass]="{ 'has-error': f.submitted && !username.valid }">
                    <label for="companyName">Firmanavn (kun erhverv)</label>
                    <input type="text" class="form-control" name="companyName" [(ngModel)]="customer.customerCompanyName" #companyName="ngModel" />
                </div>
                <div class="form-group" [ngClass]="{ 'has-error': f.submitted && !username.valid }">
                    <label for="emailAddress">Email</label>
                    <input type="email" class="form-control" name="emailAddress" [(ngModel)]="customer.email" #emailAddress="ngModel" />
                    <!--<div *ngIf="f.submitted && !emailAddress.valid" class="help-block">Emailadresse er obligatorisk</div>-->
                </div>
                <div class="form-group" [ngClass]="{ 'has-error': f.submitted && !secondEmail.valid }">
                    <label for="secondEmail">Ekstra Email</label>
                    <input type="email" class="form-control" name="secondEmail" id="secondEmail" [(ngModel)]="customer.secondEmail" #secondEmail="ngModel" />
                </div>
                <div class="form-group" [ngClass]="{ 'has-error': f.submitted && !username.valid }">
                    <label for="username">Brugernavn</label>
                    <input type="text" class="form-control" name="custusername" [(ngModel)]="customer.userName" #username="ngModel" />

                </div>

                <!-- adresse -->
                <div class="form-group" [ngClass]="{ 'has-error': f.submitted && !username.valid }">
                    <label for="addressStreet">Adresse</label>
                    <input type="text" class="form-control" name="addressStreet" [(ngModel)]="customer.address.street" #addressStreet="ngModel" />

                </div>
                <div class="form-group" [ngClass]="{ 'has-error': f.submitted && !username.valid }">
                    <label for="addressCity">By</label>
                    <input type="text" class="form-control" name="addressCity" [(ngModel)]="customer.address.city" #addressCity="ngModel" />

                </div>
                <div class="form-group" [ngClass]="{ 'has-error': f.submitted && !username.valid }">
                    <label for="addressZip">Postnummer</label>
                    <input type="text" class="form-control" name="addressZip" [(ngModel)]="customer.address.zip" #addressZip="ngModel" />

                </div>

                <div class="form-group" [ngClass]="{ 'has-error': f.submitted && !username.valid }">
                    <label for="addressPhone">Telefon</label>
                    <input type="text" class="form-control" name="addressPhone" [(ngModel)]="customer.phoneNumber" #addressPhone="ngModel" />

                </div>

                <div class="form-group" [ngClass]="{ 'has-error': f.submitted && !username.valid }">
                    <label for="addressCellphone">Mobil</label>
                    <input type="text" class="form-control" name="addressCellphone" [(ngModel)]="customer.cellphoneNumber" #addressCellphone="ngModel" />

                </div>

                <div class="text-center row">
                    <button type="submit" class="btn btn-default">Gem</button>
                </div>
            </form>
        </div>
    </div>


</div>
